import {
  IOrderTaskData,
  ICreateOrderTaskRequest,
  IUpdateOrderTaskRequest,
  IUpdateCompletedOrderTaskRequest,
} from '../../types/tasks';
import { UUID } from '../../types/shared/UUID';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';
import { cleanupRequestWithNulls } from '../cleanupRequests';

export const OrderTaskAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getTasksByOrderId: build.query<IOrderTaskData[], { orderId: UUID }>({
      query: ({ orderId }) => `/timber/api/internal/orders/${orderId}/tasks`,
      providesTags: (response, error, orderId) => [{ type: eAPITags.TasksData, orderId }],
    }),
    patchCompletedTask: build.mutation<void, { orderId: UUID; body: IUpdateCompletedOrderTaskRequest }>({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/tasks/completed-tasks/${request.body.id}`,
        method: 'PATCH',
        body: cleanupRequestWithNulls(request.body),
      }),
      invalidatesTags: (result, error, { orderId, body: { id } }) => [
        { type: eAPITags.TasksData, orderId },
        { type: eAPITags.TasksByFilterParams, id },
      ],
    }),
    patchTask: build.mutation<void, { orderId: UUID; body: IUpdateOrderTaskRequest }>({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/tasks/${request.body.id}`,
        method: 'PATCH',
        body: cleanupRequestWithNulls(request.body),
      }),
      invalidatesTags: (result, error, { orderId, body: { id } }) => [
        { type: eAPITags.TasksData, orderId },
        { type: eAPITags.TasksByFilterParams, id },
      ],
    }),
    postTask: build.mutation<void, { orderId: UUID; body: ICreateOrderTaskRequest }>({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/tasks`,
        method: 'POST',
        body: request.body,
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: eAPITags.TasksData, orderId },
        { type: eAPITags.TasksByFilterParams, id: 'LIST' },
      ],
    }),
    deleteTask: build.mutation<void, { orderId: UUID; taskId: UUID }>({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/tasks/${request.taskId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: eAPITags.TasksData, orderId },
        { type: eAPITags.TasksByFilterParams, id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetTasksByOrderIdQuery,
  usePatchCompletedTaskMutation,
  usePatchTaskMutation,
  usePostTaskMutation,
  useDeleteTaskMutation,
} = OrderTaskAPI;
